export default __webpack_public_path__ + "static/media/footer-repnik.40d346de.png";